import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTransactionStore } from '../../store';
import { useQueryParam } from './useQueryParam';

export function useTransaction() {
  const navigate = useNavigate();
  const id = useQueryParam('id');
  const { transaction, loading, error, loadTransaction } = useTransactionStore();
  const loadedId = useRef(null);

  const load = useCallback(
    (targetId) => {
      loadedId.current = targetId;
      loadTransaction(targetId);
    },
    [loadTransaction]
  );

  useEffect(() => {
    if (!id) {
      navigate('/not-found', { replace: true });
      return;
    }
    // Avoid re-fetching the same id on re-renders
    if (loadedId.current === id) return;
    load(id);
  }, [id, navigate, load]);

  // Retry: re-fetch the current id
  const retry = useCallback(() => {
    if (!id) return;
    loadedId.current = null; // reset guard so load() proceeds
    load(id);
  }, [id, load]);

  return { transaction, loading, error, retry };
}
